/*
 * Waitlist signup on /pages/inkludert. Spec: docs/inkludert-spec.md, "Waitlist signup".
 *
 * Posts the email straight to Klaviyo's client-side subscriptions API and adds the profile to the
 * list the section is configured with. It loads NOTHING: no klaviyo.js, no cookie, no tracker.
 * That is why this is not gated on cookie consent the way assets/kardima-klaviyo-onsite.js is:
 * a visitor typing their address into a form and pressing Send is asking to be emailed, which is
 * a different thing from being profiled in the background before they have agreed to anything.
 *
 * Company and list IDs, the custom source tag and every message come from the section's data
 * attributes, so this file carries no copy and no IDs.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  /* Klaviyo API revision. Bump deliberately; the request shape below is tied to it. */
  var REVISION = '2024-10-15';
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function setup(form) {
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-signup-status]');
    if (!input || !button || !status) return;

    var company = form.getAttribute('data-company') || '';
    var list = form.getAttribute('data-list') || '';
    var source = form.getAttribute('data-source') || 'inkludert-guide';

    function say(kind, text) {
      status.textContent = text || '';
      status.setAttribute('data-kind', kind);
      status.hidden = !text;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (form.classList.contains('is-pending')) return;

      var email = (input.value || '').trim();
      if (!EMAIL_PATTERN.test(email)) {
        say('invalid', form.getAttribute('data-msg-invalid'));
        input.focus();
        return;
      }
      if (!company || !list) {
        say('error', form.getAttribute('data-msg-error'));
        return;
      }

      form.classList.add('is-pending');
      button.disabled = true;
      say('', '');

      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: list } }
          }
        }
      };

      fetch(ENDPOINT + '?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'revision': REVISION
        },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          /* Klaviyo answers 202 Accepted with an empty body on success. */
          if (response.status === 202 || response.ok) {
            input.value = '';
            form.classList.add('is-done');
            say('success', form.getAttribute('data-msg-success'));
            return;
          }
          throw new Error('klaviyo ' + response.status);
        })
        .catch(function () {
          say('error', form.getAttribute('data-msg-error'));
        })
        .then(function () {
          form.classList.remove('is-pending');
          button.disabled = false;
        });
    });
  }

  function init() {
    var forms = document.querySelectorAll('[data-kardima-signup]');
    for (var i = 0; i < forms.length; i += 1) setup(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
